/* Direct checkout for the Style Steals product cards. */
document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-steals-buy-now]');
  if (!button) return;
  const form = button.closest('form');
  if (!form || button.disabled) return;
  button.disabled = true;
  button.textContent = 'Continuing…';
  const error = form.querySelector('[data-form-error]');
  if (error) error.hidden = true;
  try {
    const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) {
      const data = await response.json();
      throw new Error(data.description || 'This item could not be added.');
    }
    window.location.assign((window.Shopify?.routes?.root || '/') + 'checkout');
  } catch (err) {
    if (error) { error.textContent = err.message; error.hidden = false; }
    button.disabled = false;
    button.textContent = 'Buy it now';
  }
});
document.addEventListener('change', (event) => {
  if (!event.target.matches('[data-steals-sort]')) return;
  const url = new URL(window.location.href);
  url.searchParams.set('sort_by', event.target.value);
  window.location.assign(url.toString());
});
